import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

export const SubTitle = animated(styled.div`
  position: relative;
  text-align: center;
  width: 300px;
  max-width: 100%;
  margin: 1rem auto;
  font-weight: 500;
`);

export default ({ config, from, to, children, ...rest }) => (
  <Spring native from={from || { opacity: 0 }} to={to || { opacity: 1 }} config={config || { delay: 500 }}>
    {animation => (
      <SubTitle style={animation} {...rest}>
        {children}
      </SubTitle>
    )}
  </Spring>
);
